/* Media Query Breakpoints
 * Usage: mobile.matches
 ******************************************************* */
window.screen_lg_min = 1200;
window.screen_md_min = 992;
window.screen_sm_min = 768;
window.screen_xs_min = 480;
window.screen_md_max = (window.screen_lg_min - 1);
window.screen_sm_max = (window.screen_md_min - 1);
window.screen_xs_max = (window.screen_sm_min - 1);

window.mobile = window.matchMedia('(max-width: ' + window.screen_xs_max + 'px)');
window.tablet = window.matchMedia('(min-width: ' + window.screen_sm_min + 'px) and (max-width: ' + window.screen_sm_max + 'px)');
window.desktop = window.matchMedia('(min-width: ' + window.screen_md_min + 'px)');